import { render, staticRenderFns } from "./CommunityDetail.vue?vue&type=template&id=27895036&scoped=true&"
import script from "./CommunityDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDetail.vue?vue&type=style&index=0&id=27895036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27895036",
  null
  
)

export default component.exports